import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {SwipeablePanel} from "../../../../components/BaseComponents/SwipeablePanel/SwipeablePanel";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {AppIconThumbnail} from "../../../../components/BaseComponents/AppIconThumbnail";
import SafeHtmlContainer from "../../../../helpers/SafeHtmlContainer";
import AuthAPI from "../../../../api/AuthAPI";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import {UserChatAPI} from "../../../../api/Chat/UserChatAPI";
import {ChatRoomView, MessageContextMenuAction} from "../../../../components/ChatPanel/ChatRoom/ChatRoomView";
import {EllipsisLoader} from "../../../../components/GenericUI/EllipsisLoader/EllipsisLoader";
import {UserAdminChatAPI} from "../../../../api/Chat/UserAdminChatAPI";
import APIConfig from "../../../../api/APIConfig";
import {DLA_ADMIN_CHAT_MESSAGE} from "../../../../const/DeepLinkActionsCostants";
import {HelpdeskAPI} from "../../../../api/Helpdesk/HelpdeskAPI";
import AppConfig from "../../../../config/AppConfig";
import {SessionRatingWidget} from "./SessionRatingWidget";
import FuxEvents from "../../../../lib/FuxFramework/FuxEvents";
import {CHAT_UPDATE_MESSAGES} from "../../../../const/AppEventsCostants";
import {getSenderClassNameForUserId} from "./Utils";
import {swal, swalConfirm, swalError, swalLoading} from "../../../../helpers/SweetAlertWrapper";

const BackdropStyle = {
    position: "fixed",
    top: 0, left: 0, height: "100vh", width: "100vw",
    zIndex: 2000, backgroundColor: "rgba(0,0,0,0.7)"
}

export class HelpdeskChatPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            roomData: null,
            replyToMessage: null
        }
        this.ownMessageContextMenuActions = [
            new MessageContextMenuAction(<span className={"text-danger"}><FaSolidIcon name={"trash"}/> Elimina per tutti</span>, this.handleDeleteMessage),
            new MessageContextMenuAction(<span className={"text-dark"}><FaSolidIcon name={"reply"}/> Rispondi</span>, this.handleReplyMessage),
        ];
        this.otherMessageContextMenuActions = [
            new MessageContextMenuAction(<span className={"text-dark"}><FaSolidIcon name={"reply"}/> Rispondi</span>, this.handleReplyMessage),
        ];
    }

    isSwipeDisabled = _ => false;

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.open) {
            document.body.classList.add("noscroll");
        } else {
            document.body.classList.remove("noscroll");
        }

        if (this.props.open && !prevProps.open && !this.state.roomData) {
            this.fetchRoomData();
        }
    }

    fetchRoomData = onSuccess => {
        HelpdeskAPI.Admin.getChatRoom()
            .then(data => {
                this.setState({roomData: data}, onSuccess)
            });
    }

    handleClose = _ => {
        this.setState({roomData: null});
        this.props.onClose();
    }


    processMessageData = m => ({...m, contenuto: m.contenuto.replace(new RegExp('\{\{widget\}\}', 'g'), '')});

    messageWidgetRenderer = m => {
        if (m.metadata && m.metadata.type == "helpdesk_session_close") {
            return <SessionRatingWidget message={m}/>
        }
        return '';
    }

    sendMessageProxyAPI = (id_room, text, attachments) => {
        const p = HelpdeskAPI.Admin.sendTextMessage(id_room, text, attachments, this.state.replyToMessage?.id_messaggio);
        p.then(_ => {
            FuxEvents.emit(CHAT_UPDATE_MESSAGES, this.props.idRoom);
            this.setState({replyToMessage: null})
        });
        return p;
    }

    messageSenderRenderer = message => {
        const id = message?.metadata?.helpdesk_superadmin?.id_admin || message?.metadata?.helpdesk_admin?.id_admin || 0;
        const className = getSenderClassNameForUserId(id);
        if (message?.metadata?.helpdesk_superadmin) {
            return <b className={className}>{message.metadata.helpdesk_superadmin.nome}</b>
        } else if (message?.metadata?.helpdesk_admin) {
            return <b className={className}>{message.metadata.helpdesk_admin.nome}</b>
        } else {
            return <b>Messaggio automatico</b>
        }
    }

    handleDeleteMessage = message => {
        swalConfirm('Sei sicuro di voler eliminare questo messaggio? L\'azione sarà irreversibile')
            .then(_ => {
                swalLoading('Attendere prego...');
                HelpdeskAPI.Admin.deleteMessage(message.id_messaggio)
                    .then(_ => {
                        this.setState({roomData: null}, _ => {
                            this.fetchRoomData(_ => swal.safeClose())
                        });
                    }).catch(swalError);
            });
    }


    handleReplyMessage = message => this.setState({replyToMessage: message});
    handleReplyMessageCancel = _ => this.setState({replyToMessage: null});


    render() {
        const imageStyle = {
            backgroundImage: `url("${AppConfig.webServerUrl}/api/negozio/62/logoIcon/100")`,
            width: 48,
            height: 48,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }
        return (
            <Fragment>
                <ModalPortalHOC>
                    {this.props.open && <div style={BackdropStyle}/>}
                    <SwipeablePanel
                        swipeTreshold={5}
                        direction={'top-to-bottom'}
                        active={this.props.open}
                        onDismiss={this.handleClose}
                        disableSwipe={this.isSwipeDisabled}
                        animationSpeed={150}
                    >
                        <div className={"container-fluid rounded-top overflow-hidden bg-white py-2"}>
                            <div className={"d-flex align-items-center justify-content-between"}>
                                <div className={"d-flex align-items-center w-75"}>
                                    <div className={"mr-2 rounded-circle border"} style={imageStyle}/>
                                    <div className={"text-truncate w-75"}>
                                        <SafeHtmlContainer html={this.props.label}/>
                                    </div>
                                </div>
                                <div className={"d-flex align-items-center text-right"}>
                                    <button className={"btn btn-link text-primary"} onClick={this.handleClose}>
                                        <FaSolidIcon name={"times"}/>
                                    </button>
                                    {
                                        !!this.props.onCollapse &&
                                        <button className={"btn btn-link text-primary"} onClick={this.props.onCollapse}>
                                            <FaSolidIcon name={"compress"}/>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={"__disable-swipe"}>
                            {
                                (this.props.open && !!this.state.roomData) &&
                                <ChatRoomView
                                    idRoom={this.state.roomData.id_room}
                                    idSelf={this.props.idSelf}
                                    getMessageAPI={HelpdeskAPI.Admin.getMessages}
                                    getMediaContentUrlAPI={HelpdeskAPI.Admin.getMediaContentUrl}
                                    sendMessageAPI={this.sendMessageProxyAPI}
                                    setReadAPI={HelpdeskAPI.Admin.setRead}
                                    sendNotificationAPI={HelpdeskAPI.Admin.sendMessageNotification}
                                    fetchMessageEventName={DLA_ADMIN_CHAT_MESSAGE}
                                    messageProcessor={this.processMessageData}
                                    messageSenderRenderer={this.messageSenderRenderer}
                                    messageWidgetRenderer={this.messageWidgetRenderer}
                                    showAudioRecordingButton={true}
                                    ownMessageContextMenuActions={this.ownMessageContextMenuActions}
                                    otherMessageContextMenuActions={this.otherMessageContextMenuActions}
                                    replyToMessage={this.state.replyToMessage}
                                    onReplyCancel={this.handleReplyMessageCancel}
                                />
                            }
                            {
                                (this.props.open && !this.state.roomData) &&
                                <EllipsisLoader/>
                            }
                        </div>
                    </SwipeablePanel>
                </ModalPortalHOC>
            </Fragment>
        )
    }

}

HelpdeskChatPanel.propTypes = {
    idSelf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCollapse: PropTypes.func,
}
